import type { RestService } from '@sydle/ui-api';
import { CustomAPI } from '@sydle/ui-api';

const SCRIPT_API_CLASS_ID = '663bc10db132301d9e9bde77';

export class ScriptAPI {
  private scriptAPI: CustomAPI;

  constructor(restService: RestService) {
    this.scriptAPI = new CustomAPI(SCRIPT_API_CLASS_ID, restService);
  }

  public async getScriptContextTree(input: any): Promise<any> {
    return await this.scriptAPI.fetch('getScriptContextTree', { ...input }, {});
  }
}
